module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073e8_logo_200x200.f87b42b7.png";